import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlertService {
  success(message: string): void {
    console.log(message);
  }

  info(message: string): void {
    console.info(message);
  }

  warning(message: string): void {
    console.warn(message);
  }

  danger(message: string): void {
    console.error(message);
  }
}

@NgModule({})
export class AlertModule {
  static forRoot(_options?: any): ModuleWithProviders<AlertModule> {
    return {
      ngModule: AlertModule,
      providers: [AlertService],
    };
  }
}
